<button type="button" class="btn btn-primary btn-sm btn-animated"><span>Small button</span></button>
<button type="button" class="btn btn-primary btn-rg btn-animated">
  <span>Regular button</span>
</button>
<button type="button" class="btn btn-primary btn-md btn-animated">
  <span>Default button</span>
</button>
<button type="button" class="btn btn-primary btn-lg btn-animated"><span>Large button</span></button>
